// src/components/HeaderTop.js
import React, { useState } from 'react';
import './headertop.scss';
import { Link } from 'react-router-dom';

const HeaderTop = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="header-top">
      {/* ───── Top Row: Logo + Hamburger aligned horizontally ───── */}
      <div className="top-row">
        <div className="logo">
          <Link to="/">
            <img src="/images/MWLogo.png" alt="Malaysian Warriors Logo" />
          </Link>
        </div>

        <div
          className="menu-toggle"
          onClick={() => setMenuOpen((prev) => !prev)}
          aria-label="Toggle navigation"
          aria-expanded={menuOpen}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>

      {/* ───── Club Name centered under logo/hamburger ───── */}
      <div className="club-name">The Malaysian Warriors Football Club</div>

      {/* ───── Navigation Dropdown ───── */}
      <nav className={`nav-links ${menuOpen ? 'active' : ''}`}>
        <Link to="/gallery" onClick={() => setMenuOpen(false)}>Gallery</Link>
        <Link to="/members" onClick={() => setMenuOpen(false)}>Members</Link>
        <Link to="/contact" onClick={() => setMenuOpen(false)}>Contact</Link>
      </nav>
    </header>
  );
};

export default HeaderTop;
